import { useState, type FormEvent } from 'react'
import { useAuth } from '../auth/AuthContext.tsx'
import { Button, ErrorNote } from '../components/ui.tsx'

export function Login() {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<unknown>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(email, password)
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-sm flex-col justify-center px-6">
      <div className="mb-8 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--color-brand)] text-3xl text-white">
          ✓
        </div>
        <h1 className="text-2xl font-bold tracking-tight">Tareas</h1>
        <p className="mt-1 text-sm text-[var(--color-muted)]">Asignación semanal de casa</p>
      </div>

      {error != null && <ErrorNote error={error} />}

      <form onSubmit={submit} className="flex flex-col gap-3">
        <input
          type="email"
          inputMode="email"
          autoComplete="username"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] px-4 py-3"
        />
        <input
          type="password"
          autoComplete="current-password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] px-4 py-3"
        />
        <Button type="submit" disabled={busy} className="mt-2 w-full">
          {busy ? 'Entrando…' : 'Entrar'}
        </Button>
      </form>
    </div>
  )
}
